import React from "react";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import { questionnarieReportTheme } from "@/styles/mui/tableListTheme";
import { ThemeProvider } from "@mui/material/styles";

// Config

// CSS
import "@/styles/page/employeeShopping.css";
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import Alert from "@mui/material/Alert";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

// Mui Icon
import DownloadIcon from "@mui/icons-material/Download";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";

// Fetch
import {
  downloadPhotos,
  getReplyQuestionnaire,
  getReplyQuestionnaireExcel,
} from "@/fetch/fetchQuestionnarie";

// external library
import { PhotoSlider } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

// moment

const QuestionnaireReportPage = (props) => {
  const { open, setOpen } = props;
  const [name, setName] = React.useState("");

  // Navigate
  const navigate = useNavigate();
  const params = useParams();

  // States
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [data, setData] = React.useState({ question: "", answer: "" });

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };
  const downLoadPhotos = async (questId) => {
    try {
      setSnackSeverity("info");
      setSnackMessage("下載中...");
      setSnackOpen(true);
      await downloadPhotos(questId).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `員工問卷紀錄(${name}).zip`);
        document.body.appendChild(link);
        link.click();
        setSnackSeverity("success");
        setSnackMessage("下載成功");
      });
    } catch (err) {
      setSnackSeverity("error");
      setSnackMessage("下載失敗");
      console.log(err.message);
    }
  };
  const downLoadTemplate = async (questId) => {
    try {
      setSnackSeverity("info");
      setSnackMessage("下載中...");
      setSnackOpen(true);
      await getReplyQuestionnaireExcel(questId).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `員工問卷紀錄(${name}).xlsx`);
        document.body.appendChild(link);
        link.click();
        setSnackOpen(false);

        setSnackSeverity("success");
        setSnackMessage("下載成功");
        setSnackOpen(true);
      });
    } catch (err) {
      setSnackSeverity("error");
      setSnackMessage("下載失敗");
      console.log(err.message);
    }
  };

  const fetchAll = async () => {
    try {
      const { data: replyQuestData } = await getReplyQuestionnaire(
        params.questId,
      );
      setName(replyQuestData[0].title);
      const question = replyQuestData.reduce(
        (prev, cur) => (cur.answer?.length > prev.answer?.length ? cur : prev),
        { answer: [] || { length: 0 } },
      );
      const { answer } = question;
      setData((prev) => ({
        ...prev,
        question: answer.map((item) => item.question),
      }));
      setData((prev) => ({
        ...prev,
        answer: replyQuestData,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  React.useEffect(() => {
    fetchAll();
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`問卷表格 - ${name}`}
        history={() => navigate(-1)}
        children={
          <div>
            <IconButton
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={() => downLoadPhotos(params.questId)}
            >
              <PhotoLibraryIcon />
            </IconButton>
            <IconButton
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={() => downLoadTemplate(params.questId)}
            >
              <DownloadIcon />
            </IconButton>
          </div>
        }
      />

      <StyledPaper page={"yes"}>
        <ThemeProvider theme={questionnarieReportTheme}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              {data.question.length > 0 ? (
                <React.Fragment>
                  <TableHead>
                    <TableRow>
                      <TableCell>員工編號</TableCell>
                      <TableCell>員工姓名</TableCell>
                      {data.question.length > 0 &&
                        data.question.map((question) => (
                          <TableCell>{question}</TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.answer.length > 0 &&
                      data.answer.map((item) => {
                        return (
                          <TableRow>
                            <TableCell>{item.staff_code}</TableCell>
                            <TableCell>{item.alias}</TableCell>
                            {item.answer.map((innerItem, innerItemIndex) => {
                              let targetCell = (
                                <TableCell>{innerItem.answer}</TableCell>
                              );

                              if (
                                innerItem.type === "uploadFile" &&
                                Array.isArray(innerItem.answer)
                              ) {
                                targetCell = (
                                  <TableCell>
                                    <ImagePreview image={innerItem.answer} />
                                  </TableCell>
                                );
                              } else if (Array.isArray(innerItem.answer)) {
                                const target = innerItem.answer.filter(
                                  (filterItem) => filterItem.value,
                                );
                                targetCell = (
                                  <TableCell>
                                    {target.map((item, index) => (
                                      <Typography variant="inherit">
                                        {index + 1}. {item.label}
                                      </Typography>
                                    ))}
                                  </TableCell>
                                );
                              }

                              const balance =
                                data.question.length - item.answer.length;

                              targetCell =
                                innerItemIndex + 1 === item.answer.length &&
                                balance ? (
                                  <React.Fragment>
                                    {targetCell}
                                    {Array(balance).fill(
                                      <TableCell></TableCell>,
                                    )}
                                  </React.Fragment>
                                ) : (
                                  targetCell
                                );

                              return targetCell;
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </React.Fragment>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      沒有資料
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default QuestionnaireReportPage;

function ImagePreview(props) {
  const images = props.image ? props.image : [];
  const [visible, setVisible] = React.useState(false);
  const [index, setIndex] = React.useState(0);
  const [signedImages, setSignedImage] = React.useState([]);

  const getPreSignedUrl = (data) => {
    setSignedImage(data);
    setVisible(true);
  };

  return (
    <React.Fragment>
      <IconButton
        onClick={() => getPreSignedUrl(images)}
        disabled={images.length === 0 ? true : false}
      >
        <InsertPhotoIcon fontSize="inherit" />
      </IconButton>
      <PhotoSlider
        brokenElement={
          <Alert severity="warning">
            {`The link of picture has expired, please refresh to get new page`}
          </Alert>
        }
        loadingElement={<CircularProgress size="3rem" color="inherit" />}
        maskOpacity={0.5}
        images={signedImages.map((item, index) => ({
          src: item,
          key: index,
        }))}
        visible={visible}
        onClose={() => setVisible(false)}
        index={index}
        onIndexChange={setIndex}
      />
    </React.Fragment>
  );
}
